export default "__VITE_ASSET__xp4$FLnf__"